import clientSide from "@/helpers/clientSide";
import type { MonarchEvaluationsResult } from "@redventures/cohesion-utils";

export const CHAT_SLOT_ID = "comcastWestRvAlphaChat";
const EMPTY_COMPONENT_ID = "empty";

export const isChatSuppressedByMonarch = (
  evaluation: MonarchEvaluationsResult | null
): boolean => {
  const trafficFlow = evaluation?.source?.trafficFlow;

  if (trafficFlow?.returnType !== "experience") {
    return false;
  }

  return (trafficFlow.value?.experienceValues ?? []).some(
    ({ slot, value }) =>
      slot?.customId === CHAT_SLOT_ID &&
      value?.componentCustomId === EMPTY_COMPONENT_ID
  );
};

// Comcast's Adobe Launch rule "50 | 3P | All Pages | Nuance | DCR (Global)"
// only injects the Nuance and XA chat scripts when it finds no initialized
// chat frame; otherwise it calls the global Inq.reinitChat() instead.
export const suppressNuanceChat = (): void => {
  if (!clientSide || window.inqFrame || window.Inq) {
    return;
  }

  window.inqFrame = { Inq: { CM: { initialized: 1 } } };
  window.Inq = { reinitChat: () => {} };
  console.info("[NUANCE_CHAT] Chat has been disabled by Monarch");
};
